import { useEffect } from "react";
import { useOutletContext } from "react-router";
import TemplateStructureDetail from "./TemplateStructureDetail";

const TemplateStructure = () => {
  const {
    setBreadcrumbs,
    templateInfo,
    isEditing,
    formTemplateStructure,
    setFormTemplateStructure,
    setSelectedField,
    selectedField,
    translate,
    isNew,
    roles,
  } = useOutletContext();

  useEffect(() => {
    if (templateInfo) {
      setBreadcrumbs([
        {
          id: 0,
          title: "page_titles.form-templates",
          route: "auth.formTemplates",
        },
        { id: 1, customTitle: templateInfo?.name || "" },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateInfo]);

  return (
    <TemplateStructureDetail
      isEditing={isEditing || isNew}
      formTemplateStructure={formTemplateStructure}
      setFormTemplateStructure={setFormTemplateStructure}
      setSelectedField={setSelectedField}
      selectedField={selectedField}
      translate={translate}
      roles={roles}
    />
  );
};

export default TemplateStructure;
